import { Grid, Paper,Container } from '@mui/material'
import React from 'react'
import StaffForm from '../Components/StaffForm'
import StaffInfo from '../Components/StaffInfo'
import AdminTemplate from '../Components/Template/AdminTemplate'


function RetireTeachingStaff() {
    const retireTeachingStaffScreen=()=>{
        return(
            <Container alignItems="center" sx={{mt:5}}>
            <Grid
           container
           spacing={5}
           direction="row"
           alignItems="center"
           justify="center"
           //style={{ minHeight: '100vh' }}
         >
                  <Grid item xs={12} md={5} lg={5}>
                  <Paper
                           sx={{
                             p: 2,
                             display: 'flex',
                             flexDirection: 'column',
                             height: "auto",
                           }}
                         >
                             <StaffForm is_retire={true} staff_type={"teaching"}/>
                         </Paper>
                  </Grid>
                  <Grid item xs={12} md={7} lg={7}>
                  <Paper
                           sx={{
                             p: 2,
                             display: 'flex',
                             flexDirection: 'column',
                             height: "auto",
                           }}
                         >
                          <StaffInfo is_retire={true} staff_type={"teaching"}/>
                           
                         </Paper>
                  </Grid>
         
                 </Grid>
                 </Container>
        )
    }
  return (
  <AdminTemplate>
    {retireTeachingStaffScreen()}
  </AdminTemplate>
  )
}

export default RetireTeachingStaff